import Layouts from "./layouts/index.js";
const { // plop_marker:segment_index_import_layout
ContactOptionsEmbedded, BookAMeetingEmbedded, WhatsNewItemsListEmbedded, MarkdownEmbedded } = Layouts;
export default {
    // plop_marker:segment_index_add_layout
    ContactOptionsEmbeddedComponent: {
        type: "ContactOptionsEmbeddedComponent",
        title: "Contact Options",
        imgSrc: "/static/img/segments/layouts/contact-options-embedded.png",
        config: ContactOptionsEmbedded.ContactOptionsEmbeddedConfig,
        advancedConfig: ContactOptionsEmbedded.ContactOptionsEmbeddedAdvancedConfig,
        component: ContactOptionsEmbedded.ContactOptionsEmbeddedComponent
    },
    BookAMeetingEmbeddedComponent: {
        type: "BookAMeetingEmbeddedComponent",
        title: "Book A Meeting",
        imgSrc: "/static/img/segments/layouts/book-a-meeting-embedded.png",
        config: BookAMeetingEmbedded.BookAMeetingEmbeddedConfig,
        advancedConfig: BookAMeetingEmbedded.BookAMeetingEmbeddedAdvancedConfig,
        component: BookAMeetingEmbedded.BookAMeetingEmbeddedComponent
    },
    WhatsNewItemsListEmbeddedComponent: {
        type: "WhatsNewItemsListEmbeddedComponent",
        title: "Whats New Items List",
        imgSrc: "/static/img/segments/layouts/whats-new-items-list-embedded.png",
        config: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedConfig,
        advancedConfig: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedAdvancedConfig,
        component: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedComponent,
        dynamicsFetch: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedDynamicsFetch
    },
    MarkdownEmbeddedComponent: {
        type: "MarkdownEmbeddedComponent",
        title: "Markdown",
        imgSrc: "/static/img/segments/layouts/markdown-embedded.png",
        config: MarkdownEmbedded.MarkdownEmbeddedConfig,
        advancedConfig: MarkdownEmbedded.MarkdownEmbeddedAdvancedConfig,
        component: MarkdownEmbedded.MarkdownEmbeddedComponent
    }
};
